module.exports = __webpack_public_path__ + "img/software_system.42c585e4.jpg";